"use strict";

var _createClass = function () {
  function n(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, o) {
    return t && n(e.prototype, t), o && n(e, o), e;
  };
}();

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var React = require("react"),
    PropTypes = require("prop-types"),
    NextIcon = require("../icons/NextIcon.js");

function onToggle(e) {
  var t = e.target.parentNode.getElementsByClassName("blx-accordion-content")[0];
  t.style.maxHeight ? t.style.maxHeight = null : t.style.maxHeight = t.scrollHeight + "px";
}

var AccordionSection = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }

  return _inherits(e, React.Component), _createClass(e, [{
    key: "componentDidMount",
    value: function value() {
      this.props.open && (this.content.style.maxHeight = this.content.scrollHeight + "px");
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.props.open && (this.content.style.maxHeight = this.content.scrollHeight + "px");
    }
  }, {
    key: "render",
    value: function value() {
      var t = this;
      return React.createElement("div", {
        style: this.props.style,
        className: "blx-accordion-section " + this.props.className
      }, React.createElement("input", {
        id: this.props.id,
        type: "checkbox",
        name: "blx-accordion-tab",
        defaultChecked: this.props.open,
        onChange: this.props.onToggle
      }), React.createElement("label", {
        htmlFor: this.props.id,
        className: "blx-accordion-trigger"
      }, React.createElement(NextIcon, {
        className: "blx-accordion-arrow"
      }), this.props.trigger), React.createElement("div", {
        className: "blx-accordion-content",
        ref: function ref(e) {
          return t.content = e;
        }
      }, this.props.children));
    }
  }]), e;
}();

AccordionSection.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string.isRequired,
  open: PropTypes.bool,
  trigger: PropTypes.object.isRequired,
  onToggle: PropTypes.func
}, AccordionSection.defaultProps = {
  className: "",
  style: null,
  open: !1,
  onToggle: onToggle
}, module.exports = AccordionSection;